import React, { Component } from "react";
import AuthHelperMethods from "../../util/AuthHelperMethods";

export default function withAuth(AuthComponent: any) {
  const Auth = new AuthHelperMethods();

  return class AuthWrapped extends Component {
    state = {
      confirm: null,
      loaded: false
    };

    componentDidMount() {
      if (!Auth.loggedIn()) {
        window.location.href = "/login";
      } else {
        try {
          const confirm = Auth.getConfirm();
          // console.log("confirmation is:", confirm);
          this.setState({
            confirm: confirm,
            loaded: true
          });
        } catch (err) {
          console.log(err);
          Auth.logout();
          window.location.href = "/login";
        }
      }
    }

    render() {
      if (this.state.loaded === true) {
        if (this.state.confirm) {
          // console.log("confirmed!");
          return <AuthComponent confirm={this.state.confirm} />;
        } else {
          // console.log("not confirmed!");
          return null;
        }
      } else {
        return null;
      }
    }
  };
}
